import React, {useEffect, useState} from 'react';
import {ArrowRight, CheckCircle} from 'lucide-react';
import {Link, useParams, useSearchParams} from "react-router-dom";
import {Coding} from "@/lib/helper/coding";
import VideoPlayer from "@/pages/lms/level/[id]/_section/VideoSection";
import QuizComponent from "@/pages/lms/level/[id]/_section/QuizeSection";
import {URLS} from "@/lib/urls";
import RenderIf from "@/components/render-if";
import {Skeleton} from "antd";
import {useApiLmLevelDetail} from "@/api/lms";
import LmsTextStepSection from "@/pages/lms/level/[id]/_section/LmsTextStepSection";
import "react-use-audio-recorder/dist/index.css";
import AudioRecorderCustom from "@/pages/lms/level/[id]/_section/AudioRecorder";
import UploadSection from "@/pages/lms/level/[id]/_section/UploadSection";
import LmsLevelIdNeedLoginSection from "@/pages/lms/level/[id]/_section/LmsLevelIDNeedLoginSection";
import {getAccessToken} from "@/lib/services/tokenService";
import {useGetCurrentUser} from "@/api/auth";
import LmsLevelIDNeedStudentSection from "@/pages/lms/level/[id]/_section/LmsLevelIDNeedStudentSection";
import LmsLevelIDNeedTakenUnitSection from "@/pages/lms/level/[id]/_section/LmsLevelIDNeedTakenUnitSection";


function LmsLevelViewPage() {

    const [videoCompleted, setVideoCompleted] = useState(false);
    const [showQuiz, setShowQuiz] = useState(false);
    const [quizResult, setQuizResult] = useState(null);
    const [levelCounter, setLevelCounter] = useState({current: 0, total: 0});
    const [canContinue, setCanContinue] = useState(true)
    const [viewState, setViewState] = useState('ok')

    const token = getAccessToken()
    const {data: userData} = useGetCurrentUser({enabled: !!token})


    const [currentGroup, setCurrentGroup] = useState({})
    const [searchParams, setSearchParams] = useSearchParams();

    const params = useParams();
    const type = params.type;


    let levelId = searchParams.get("id");

    levelId = Coding.decode(levelId);

    const {data: levelDetail, isPending, isSuccess} = useApiLmLevelDetail(levelId)

    useEffect(() => {
        const callBack = () => {
        }
        if (levelDetail?.data?.data?.need_login) {
            if (!token) {
                setViewState('needLogin')
                return callBack();
            }

            if (token && !userData?.data?.data?.id) {
                setViewState('needLogin')
                return callBack();
            }


        }

        if (levelDetail?.data?.data?.need_student) {

            if (!token) {
                setViewState('needLogin')
                return callBack();
            }

            if (!userData?.data?.data?.useracademy?.student) {
                setViewState('needStudent')
                return callBack();
            }
        }


        if (levelDetail?.data?.data?.need_takenunit) {

            if (!token) {
                setViewState('needLogin')
                return callBack();
            }

            if (!userData?.data?.data?.useracademy?.student) {
                setViewState('needStudent')
                return callBack();
            }

            if (!levelDetail?.data?.data?.takenunit_detail?.id) {
                setViewState('needTakenUnit')
                return callBack();
            }
        }


    }, [levelDetail, levelId, token, userData]);

    useEffect(() => {

        setCurrentGroup(levelDetail?.data?.data?.group)

        setLevelCounter({current: levelDetail?.data?.data?.current_level, total: levelDetail?.data?.data?.total_level})

    }, [levelId, levelDetail])


    const handleVideoEnded = () => {
        setVideoCompleted(true);
    };

    const handleStartQuiz = () => {
        setShowQuiz(true);
    };

    const handleQuizComplete = (passed, score) => {
        setQuizResult({passed, score});
    };

    return (
        <div className="">
            <div className="max-w-4xl mx-auto px-4 py-8">
                {/* Header Section */}
                <div className=" backdrop-blur-sm border-b border-gray-200/50 dark:border-gray-600 top-0 z-50 rounded-lg mb-2">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                        {/* Back Button */}
                        <Link to={URLS.lms.levels + '?id=' + Coding.encode(levelDetail?.data?.data?.group?.id)}>
                            <button

                                className="flex items-center text-blue-600 hover:text-blue-700 mb-6 transition-colors duration-200"
                            >
                                <ArrowRight className="w-5 h-5 ml-2"/>
                                <span className="font-medium">بازگشت به لیست درس‌ها</span>
                            </button>
                        </Link>

                        <RenderIf condition={isPending}>
                            <Skeleton active={true} className="w-full h-full"/>
                        </RenderIf>

                        <div className="flex justify-between">
                            <div>
                                <RenderIf condition={currentGroup?.id}>
                                    <div className="flex items-center mb-6">
                                        <div className="w-16 h-16 rounded-2xl overflow-hidden ml-4 shadow-lg">
                                            <img
                                                src={currentGroup?.file}
                                                alt={currentGroup?.title}
                                                className="w-full h-full object-cover"

                                            />
                                        </div>
                                        <div>
                                            <h1 className="text-3xl font-bold  mb-2">
                                                {levelDetail?.data?.data?.title}

                                            </h1>
                                            <p className="">
                                                {currentGroup?.title}
                                            </p>
                                        </div>
                                    </div>
                                </RenderIf>

                            </div>
                            <div>
                                <RenderIf condition={levelCounter?.total}>
                                    <div className="text-left">
                                        <div className="text-sm  mb-1">مرحله</div>
                                        <div className="text-2xl font-bold text-blue-600">
                                            {levelCounter.current} <span
                                            className={''}>از</span> {levelCounter.total}
                                        </div>
                                        <div className="w-24 bg-gray-200 rounded-full h-2 mt-2">
                                            <div
                                                className="bg-blue-600 h-2 rounded-full transition-all duration-500"
                                                style={{width: `${(levelCounter.current / levelCounter.total) * 100}%`}}
                                            />
                                        </div>
                                    </div>
                                </RenderIf>
                            </div>
                        </div>

                    </div>
                </div>


                <div className=" rounded-xl p-6 shadow-lg border border-gray-100 dark:border-gray-600">

                    <RenderIf condition={viewState === 'needLogin'}>
                        <LmsLevelIdNeedLoginSection/>
                    </RenderIf>

                    <RenderIf condition={viewState === 'needStudent'}>
                        <LmsLevelIDNeedStudentSection/>
                    </RenderIf>

                    <RenderIf condition={viewState === 'needTakenUnit'}>
                        <LmsLevelIDNeedTakenUnitSection levelDetail={levelDetail}/>
                    </RenderIf>


                    <RenderIf condition={viewState === 'ok'}>


                        <RenderIf condition={isPending}>
                            <Skeleton loading={true} active={true} className="w-full h-full"/>
                        </RenderIf>

                        <RenderIf condition={isSuccess}>
                            <h2 className="text-xl font-semibold mb-4 ">محتوای درس</h2>

                            <RenderIf condition={['textrecord'].includes(type)}>
                                <LmsTextStepSection levelDetail={levelDetail?.data?.data}/>
                                <div className="flex justify-center">
                                    <AudioRecorderCustom lessonDetail={levelDetail} setCanContinue={setCanContinue}/>
                                </div>
                            </RenderIf>

                            <RenderIf condition={['upload'].includes(type)}>
                                <LmsTextStepSection levelDetail={levelDetail?.data?.data}/>
                                <div className="flex justify-center">
                                    <UploadSection lessonDetail={levelDetail} setCanContinue={setCanContinue}/>
                                </div>
                            </RenderIf>

                            <RenderIf condition={['text'].includes(type)}>
                                <LmsTextStepSection levelDetail={levelDetail?.data?.data}/>
                            </RenderIf>

                            <RenderIf
                                condition={['quranvideo', 'practice', 'review', 'hefz', 'iqra', 'reading', 'theme'].includes(type)}>
                                <VideoPlayer
                                    src={levelDetail?.data?.data?.file}
                                    poster={levelDetail?.data?.data?.file2}
                                    onVideoEnded={handleVideoEnded}
                                    setCanContinue={setCanContinue}
                                />

                            </RenderIf>

                            <RenderIf condition={levelDetail?.data?.data?.questions.length > 0}>

                                <QuizComponent
                                    levelDetail={levelDetail}
                                    setCanContinue={setCanContinue}
                                    questions={levelDetail?.data?.data?.questions}
                                    onQuizComplete={handleQuizComplete}
                                />
                            </RenderIf>
                        </RenderIf>
                    </RenderIf>
                </div>


                {/* محتوای اصلی */}
                <div className="space-y-8">
                    <RenderIf
                        condition={levelCounter.total === levelCounter.current && !levelDetail?.data?.data?.next_level?.id}>
                        <div className=" rounded-xl p-8 mt-4 shadow-lg border border-gray-100 dark:border-gray-600 text-center">
                            <Link to={URLS.lms.levels + '?id=' + Coding.encode(levelDetail?.data?.data?.group?.id)}>
                                <button

                                    className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white text-lg font-medium rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
                                >

                                    بازگشت به لیست درس‌ها
                                </button>
                            </Link>
                        </div>
                    </RenderIf>

                    <RenderIf condition={levelDetail?.data?.data?.next_level?.id}>
                        <div className=" rounded-xl p-8 mt-4 shadow-lg border border-gray-100 dark:border-gray-600 text-center">
                            <Link
                                to={URLS.lms.levelView + '/' + levelDetail?.data?.data?.next_level?.type + '?id=' + Coding.encode(levelDetail?.data?.data?.next_level?.id)}>
                                <button

                                    className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white text-lg font-medium rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
                                >
                                    <ArrowRight size={20}/>
                                    ادامه
                                </button>
                            </Link>
                        </div>
                    </RenderIf>
                    <>


                        <div className="hidden  rounded-xl p-8 shadow-lg border border-gray-100 dark:border-gray-600 text-center">
                            <div className="mb-6">
                                <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4"/>
                                <h3 className="text-xl font-semibold  mb-2">
                                    تبریک! شما ویدیو را کامل مشاهده کردید
                                </h3>
                                <p className="">
                                    اکنون می‌توانید در آزمون این مرحله شرکت کنید
                                </p>
                            </div>

                            <button
                                onClick={handleStartQuiz}
                                className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white text-lg font-medium rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
                            >
                                <ArrowRight size={20}/>
                                شروع آزمون
                            </button>
                        </div>

                    </>

                </div>
            </div>
        </div>
    );
}

export default LmsLevelViewPage;